


































































































































































import { Component, Watch, Mixins, VModel } from 'vue-property-decorator'

Component.registerHooks(['validations', 'beforeRouteLeave'])

import { mask } from 'vue-the-mask'

import { mdiClose } from '@mdi/js'

import type { AppealTopic } from '@/api'

import { Alert } from '@/mixins/Alert'
import LabelRequired from '@/components/lib/LabelRequired.vue'
import { feedback } from '@/store/modules/feedback'
import { FeedbackValidations } from '@/mixins/forms/FeedbackValidations'
import { DisabledInput } from '@/components/lib/mixins/DisabledInput'
import { mock } from '@/tools'

@Component<FeedbackDialog>({
  directives: { mask },
  components: {
    LabelRequired,
  },
})
class FeedbackDialog extends Mixins<Alert, FeedbackValidations, DisabledInput>(
  Alert,
  FeedbackValidations,
  DisabledInput
) {
  @VModel({
    type: Boolean,
    default: false,
    validator: value => typeof value === 'boolean',
  })
  isShowFeedbackModal!: boolean

  feedbackModule = feedback.context(this.$store)
  icons = {
    mdiClose,
  }

  topics: AppealTopic[] = []

  form = {
    no_response_required: false,
    email_response: false,
    email: '',
    mobilePhone: '',
    lastName: '',
    middleName: '',
    firstName: '',
    message: '',
    // NOTE: -1 магическое число, тк при инициализации значения как null, TS выдает ошибку
    theme_id: -1,
  }

  resetForm() {
    this.form.no_response_required = false
    this.form.email_response = false
    this.form.email = ''
    this.form.mobilePhone = ''
    this.form.lastName = ''
    this.form.middleName = ''
    this.form.firstName = ''
    this.form.message = ''
    ;(this.form.theme_id = null), this.$v.form.$reset()
  }
  @Watch('isShowFeedbackModal', { immediate: true })
  createCleanForm() {
    this.resetForm()
  }

  async created() {
    const result = await this.feedbackModule.actions.getFeedbackTopics()
    this.topics = result.list
  }

  async submitFeedback() {
    this.$v.form.$touch()
    if (!this.$v.form.$anyError) {
      try {
        await this.feedbackModule.actions.sendFeedback(this.form)
        this.openAlert({ type: 'success', message: 'Обратная связь успешно отправлено', duration: 4000 })
        this.isShowFeedbackModal = false
      } catch (error) {
        mock(error)
      }
    }
  }
}

export default FeedbackDialog
